import { useContext, useMemo } from 'react'
import CadUsefulDataContext from 'modules/cadUsefulData/context'

/**
 * Hook to access CAD useful data in any CAD page component
 * Usage: const { cadOutOfService, fineTypes, ...otherData } = useCadUsefulData()
 * 
 * Garantit que les propriétés ne sont jamais undefined (retourne [] par défaut)
 */
const useCadUsefulData = () => {
  const cadUsefulData = useContext(CadUsefulDataContext)
  
  return useMemo(() => {
    return new Proxy(cadUsefulData || {}, {
      get: (target, prop) => {
        return target[prop] !== undefined ? target[prop] : []
      }
    })
  }, [cadUsefulData])
}

export default useCadUsefulData
